import { render, staticRenderFns } from "./HomeOwnersDelete.vue?vue&type=template&id=529c975f&"
import script from "./HomeOwnersDelete.vue?vue&type=script&lang=js&"
export * from "./HomeOwnersDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports